<template lang="pug">
    section.ParagraphKeyFigures
      .ParagraphKeyFigures_wrapper
        .ParagraphKeyFigures_item(v-for="(kf, index) in item.keyFigures", :key="index")
          animate-number.ParagraphKeyFigures_itemNumber(
            duration="500"
            easing="easeOutQuad"
            from="0"
            mode="manual"
            :formatter="formatter"
            :to="kf.number"
            ref="numbers"
          )
          p.ParagraphKeyFigures_itemTitle {{ kf.title }}
</template>

<script>
import Vue from 'vue'
import VueAnimateNumber from 'vue-animate-number'
import scrollUpdate from '@/mixins/scrollUpdate'
Vue.use(VueAnimateNumber)

export default {
  props: ['item'],
  mixins: [scrollUpdate],
  components: {
    VueAnimateNumber
  },
  data () {
    return {}
  },
  methods: {
    formatter (num) {
      return Math.round(num)
    },
    onEnter () {
      for (const number of this.$refs.numbers) {
        number.start()
      }
    },
    onExit () {

    }
  },
  mounted () {

  }
}

</script>

<style lang="stylus" scoped>

  .ParagraphKeyFigures
    box-sizing: border-box
    width 100%
    background-color $beige
    padding 20px
    background-image  url('/img/backgrounds/key-figures_background.jpg')
    background-position 50% 50%
    background-size cover

    @media $mq_m
      padding 7.5vw 40px

    &_wrapper
      max-width 1100px
      margin 0 auto
      display flex
      justify-content space-around
      align-items center
      flex-direction: column

      @media $mq_m
        flex-direction: row

    &_item
      text-align: center;

      & + .ParagraphKeyFigures_item
        @media $mq_s_only
          margin-top 20px

    &_itemNumber

      display: inline-block
      font-family: 'Sectra Display';
      font-size: 50px;
      line-height: 60px;

      @media $mq_m
        font-size: 75px;
        line-height: 80px;

      @media $mq_xl
        font-size: 100px;
        line-height: 120px;

    &_itemTitle

      font-weight 400
      font-size: 14px;
      line-height: 28px;
      margin-top 25px

      @media $mq_m
        font-size: 16px;
        line-height: 32px;

      @media $mq_xl
        font-size: 18px;
        line-height: 35px;

</style>
